import { Check, PenLine } from "lucide-react";

interface CompletedSectionHeaderProps {
  title: string;
  value: string;
  onEdit: (event: React.MouseEvent) => void;
  isCompleted?: boolean;
}

export const CompletedSectionHeader = ({ title, value, onEdit, isCompleted = false }: CompletedSectionHeaderProps) => (
  <div className="flex flex-col">
    <div className="flex items-center justify-between text-sm">
      <div className="flex items-center gap-2">
        {isCompleted && <Check className="h-4 w-4 text-green-500" />}
        <span className="text-sm font-bold">{title}</span>
      </div>
      <div className="flex items-center ml-2">
        <span className="text-sm">{value}</span>
        <button
          onClick={onEdit}
          className="ml-2 px-2 rounded-lg transition-colors"
        >
          <PenLine className="h-4 w-4 text-gray-400 hover:text-accent" />
        </button>
      </div>
    </div>
  </div>
);
